export function formatPoints(value) {
  const number = Number(value || 0)
  return number.toLocaleString('es-MX', { maximumFractionDigits: 2 })
}

export const normalizedSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

export function pointsPrice(reward, variant = '', selectedTokens = []) {
  const override = Number(reward.reward_points_price || 0)
  let base = override
  if (base <= 0) {
    if (variant === 'fria' && reward.price_cold != null && reward.price_cold !== '') base = Number(reward.price_cold)
    else if (variant === 'caliente' && reward.price_hot != null && reward.price_hot !== '') base = Number(reward.price_hot)
    else if (reward.price != null && reward.price !== '') base = Number(reward.price)
    else base = Number(reward.points_price || reward.price_hot || reward.price_cold || 0)
  }
  const rule = reward.customization_rule
  if (!rule || !selectedTokens.length) return base
  const options = (reward.customization_groups || []).flatMap(g => g.options || [])
  return base + selectedTokens.slice(Math.max(0, Number(rule.included_count || 0))).reduce((total, token) => {
    const fixed = Number(rule.extra_points ?? rule.extra_price ?? 0)
    const option = options.find(o => o.id_token === token)
    return total + (fixed > 0 ? fixed : Number(option?.points_delta ?? option?.price_delta ?? 0))
  }, 0)
}

export function variants(reward) {
  const list = []
  if (Number(reward.has_hot) && reward.price_hot != null && reward.price_hot !== '') list.push({ value: 'caliente', label: 'Caliente' })
  if (Number(reward.has_cold) && reward.price_cold != null && reward.price_cold !== '') list.push({ value: 'fria', label: 'Frío' })
  return list
}

export function rewardCards(rewards) {
  return rewards.map(r => ({ ...r, _variants: variants(r), _variant: variants(r)[0]?.value || '', _groupKey: r.category_slug || r.category_name || 'afrogato', _groupLabel: r.category_name || r.category_badge_label || 'Afrogato', card_key: r.id_token }))
}

export function minimumPoints(reward) {
  return Math.min(...(variants(reward).length ? variants(reward).map(v => pointsPrice(reward, v.value)) : [pointsPrice(reward)]))
}

export function priceLabel(reward) {
  const prices = (variants(reward).length ? variants(reward).map(v => pointsPrice(reward, v.value)) : [pointsPrice(reward)])
  const low = Math.min(...prices); const high = Math.max(...prices)
  return low === high ? `${formatPoints(low)} pts` : `${formatPoints(low)}–${formatPoints(high)} pts`
}

export function filterRewards(cards, { search = '', category = '', affordable = false, balance = 0 } = {}) {
  const terms = normalizedSearch(search).split(/\s+/).filter(Boolean)
  return cards.filter(r => {
    const text = normalizedSearch([r.name, r.description, r._groupLabel, ...(r._variants || []).map(v => v.label)].join(' '))
    return (!category || r._groupKey === category) && terms.every(t => text.includes(t))
      && (!affordable || (r.available && minimumPoints(r) > 0 && minimumPoints(r) <= balance))
  })
}

export function customizationValid(reward, tokens = []) {
  const rule = reward.customization_rule || {}
  if (tokens.length < Number(rule.min_select_total || 0) || (Number(rule.max_select_total) > 0 && tokens.length > Number(rule.max_select_total))) return false
  const known = new Map((reward.customization_groups || []).flatMap(g => (g.options || []).map(o => [o.id_token, o])))
  if (tokens.some(t => !known.has(t) || known.get(t).availability_status === 'sold_out')) return false
  return (reward.customization_groups || []).every(g => {
    const count = tokens.filter(t => (g.options || []).some(o => o.id_token === t)).length
    const min = Math.max(Number(g.min_select || 0), Number(g.is_required || 0))
    const max = g.selection_type === 'single' ? 1 : Number(g.max_select || 0)
    return count >= min && (!max || count <= max)
  })
}

/** Preserve choices while refreshing; unavailable lines require explicit removal. */
export function reconcileCart(cart, rewards) {
  const known = new Map(rewards.map(r => [r.id_token, r]))
  return Object.fromEntries(Object.entries(cart).map(([key, line]) => {
    const reward = known.get(line.product_token)
    const validVariant = !line.variant || variants(reward || {}).some(v => v.value === line.variant)
    const valid = reward?.available && validVariant && customizationValid(reward, line.customization_options || [])
    return [key, { ...line, available: Boolean(valid), stock_limit: reward ? (reward.stock_limit ?? reward.reward_stock_quantity ?? null) : line.stock_limit,
      ...(valid ? { unit_points: pointsPrice(reward, line.variant, line.customization_options || []), name: reward.name } : {}),
      issue: !reward?.available ? 'Este producto ya no está disponible.' : !valid ? 'La personalización cambió. Quita el producto y vuelve a elegirlo.' : '' }]
  }))
}
